import type { LogEntry } from './types'

export const MAX_LOG_COUNT = 200

export const TYPE_LABELS: Record<LogEntry['type'], string> = {
  connect: '연결',
  response: '응답',
  event: '이벤트',
  error: '에러',
  info: '정보',
}
